import { insightsLoadingCopy as copy } from '@testfeed/product-language'
import { insightsPageSectionIds } from '@testfeed/shopify-contracts'
import { SkeletonBodyText } from '../shims/SkeletonBodyTextShim'
import { InsightCardSkeleton, type InsightSkeletonKind } from './cards/InsightCardSkeleton'

type LoadingCard = { kind: InsightSkeletonKind; rows?: number }
const titles = copy.loadingTitles
// Initial layout hints only. Loaded cards always use the validated server presentation. The sections are the
// page's own list, so a section added to the page must be given its placeholder here.
const placeholders: Record<(typeof insightsPageSectionIds)[number], { title: string; cards: LoadingCard[] }> = {
  'repeat-buying': { title: titles.repeatBuying, cards: [{ kind: 'metric' }, { kind: 'population-steps' }] },
  'product-pairs': { title: titles.productPairs, cards: [{ kind: 'relationship-list', rows: 3 }] },
  'paid-product-history': { title: titles.productHistory, cards: [{ kind: 'list-group', rows: 3 }] },
  'product-mix': { title: titles.productMix, cards: [{ kind: 'category-breakdown', rows: 5 }] },
}

/** Each destination keeps its own native section; no simulated numbers or active controls. */
export function InsightsLoading() {
  return (
    <s-stack gap="large">
      <div role="status" aria-label={copy.loading}>
        <s-paragraph>{copy.loading}</s-paragraph>
      </div>
      {insightsPageSectionIds.map((id) => {
        const { title, cards } = placeholders[id]
        return (
          <s-section key={id}>
            <div role="region" aria-label={copy.loadingCard(title)} aria-busy="true" data-insight-skeleton>
              <s-stack gap="base" aria-hidden="true">
                <div style={{ width: '12rem', maxWidth: '100%' }} data-insight-skeleton-heading>
                  <SkeletonBodyText lines={1} />
                </div>
                {cards.map((card, index) => (
                  <InsightCardSkeleton key={index} {...card} />
                ))}
              </s-stack>
            </div>
          </s-section>
        )
      })}
    </s-stack>
  )
}
